import { render, staticRenderFns } from "./CarouselMultiRowSlidesLayout.vue?vue&type=template&id=f2b72186&"
import script from "./CarouselMultiRowSlidesLayout.vue?vue&type=script&lang=js&"
export * from "./CarouselMultiRowSlidesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports